import React from "react";
import ReportCard from "./ReportCard";
import { reports } from "../reports";

export default function Reports() {
  return (
    <div className="pt-4 d-flex flex-column gap-3 w-100">
      <div>
        <h4 className="fw-bold text-primary">Reports</h4>
        <p>
          <span className="text-secondary fw-semibold bg-light ps-2 pe-2 rounded">
            FFCC
          </span>
          provides various reports that meet your exact requirements.
        </p>
      </div>
      {reports.map((report) => {
        return (
          <ReportCard
            key={report.title}
            image={report.image}
            title={report.title}
            description={report.description}
            moreInfo={report.moreInfo}
            file={report.file}
          />
        );
      })}
    </div>
  );
}
